
export function filterToDistinct<T>(entries: T[]) {
   let uniqueEntries = new Set<any>();

    for (let entry of entries) {
      if (uniqueEntries.has(entry))
        continue;

      uniqueEntries.add(entry);
    }

    return Array.from(uniqueEntries);
}
